module.exports = __webpack_public_path__ + "img/avatar7.3ee7e386.png";